
export const getNetworkColor = (networkType: string, index: number, isDark: boolean) => {
  const colors = {
    light: [
      'hsl(var(--primary))',      // Primary theme color
      '#0EA5E9',                  // Ocean Blue
      '#F97316',                  // Bright Orange
      '#8B5CF6',                  // Vivid Purple
      '#D946EF',                  // Magenta Pink
      '#10B981',                  // Green
    ],
    dark: [
      '#FF6600',                  // Dark theme primary (orange accent)
      '#0F9DEA',                  // Blue primary for dark theme
      '#6E59A5',                  // Tertiary Purple
      '#D6BCFA',                  // Light Purple
      '#0EA5E9',                  // Ocean Blue
      '#10B981',                  // Green
    ]
  };

  const colorSet = isDark ? colors.dark : colors.light;
  
  switch (networkType) {
    case '5g':
      return colorSet[0];
    case 'fiber':
      return colorSet[1];
    case 'satcom':
      return colorSet[2];
    case 'radio':
      return colorSet[3];
    case 'mesh':
      return colorSet[4];
    default:
      return colorSet[index % colorSet.length];
  }
};
